// FAQ関連のJavaScript
$(document).on('turbolinks:load', function() {
  // FAQページが存在する場合のみ実行
  if ($('#faq').length === 0) return;

  // カテゴリ目次のトグル機能
  $('.toc-toggle-btn').on('click', function() {
    const $tocContent = $('.toc-content');
    const $toggleBtn = $(this);
    const $textShow = $toggleBtn.find('.toc-text-show');
    const $textHide = $toggleBtn.find('.toc-text-hide');
    
    if ($tocContent.is(':visible')) {
      // 閉じる
      $tocContent.slideUp(300);
      $toggleBtn.removeClass('active');
      $textShow.show();
      $textHide.hide();
    } else {
      // 開く
      $tocContent.slideDown(300);
      $toggleBtn.addClass('active');
      $textShow.hide();
      $textHide.show();
    }
  });

  // FAQアコーディオン機能
  $('.faq-question').on('click', function() {
    const $faqItem = $(this).closest('.faq-item');
    const $answer = $faqItem.find('.faq-answer');
    const $toggleIcon = $(this).find('.toggle-icon i');
        
    // クリックされたFAQを開閉
    $faqItem.toggleClass('active');
    $answer.slideToggle(300);
    $(this).toggleClass('active');
  });

  // カテゴリリンクのスムーズスクロール
  $('.toc-link').on('click', function(e) {
    e.preventDefault();
    
    const targetId = $(this).attr('href');
    const $target = $(targetId);
    
    if ($target.length) {      
      // スムーズスクロール
      $('html, body').animate({
        scrollTop: $target.offset().top - 100
      }, 100);
    }
  });
}); 